import React from 'react';
import { BrowserRouter as Router, Route, Redirect,Switch } from 'react-router-dom';
import { isAuthenticated } from './services/auth';
import AdminSideBar from './globals/Layout/Admin/Sidebar';
import LayoutComponent from './globals/Layout/Layout';
import ErrorServer from './globals/Layout/Error/ErrorServer';
import LandingPage from './components/LandingPage';
import AKLIOPage from './components/AKLIOPage';
import AKLIOLegalPage from './components/AKLIOLegalPage';
import UpdatePassword from './components/UpdatePassword';


const ConfigRouter: React.FC = () => {
  return (

    <Router>       
      <Switch>
      <PublicRouteWrapper path='/' exact component={LandingPage} layout={LayoutComponent} />    
       <PublicRouteWrapper path='/aklio' exact component={AKLIOPage} layout={LayoutComponent} />
       <PublicRouteWrapper path='/aklio/legal/:slug' exact component={AKLIOLegalPage} layout={LayoutComponent} />
       <Route path='/error-server' exact component={ErrorServer}  />  
       <PublicRouteWrapper path='/update-password/:token' exact component={UpdatePassword} layout={LayoutComponent} />  


      </Switch> 
    </Router>

  );
};

const PublicRouteWrapper = (props: any) => {
  const { component: Component, layout: LayoutComponent, ...rest } = props;
  return (
    <Route {...rest} render={(props: any) =>
      <LayoutComponent {...props}>
        <Component {...props} />
      </LayoutComponent>
    } />
  );
}
function PrivateRouteWrapper(props: any) {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() ? (
          <AdminSideBar {...props}>
            <Component {...props} />
          </AdminSideBar>
        ) : (
          <Redirect
            to={{
              pathname: "/",
            }}
          />
        )
      }
    />
  );
}





export default ConfigRouter;
